// Polyfill for Promise.allSettled
// Place this file in your app entry (e.g. src/main.tsx) with `import './utils/polyfills/promiseAllSettled'`

if (typeof (Promise as any).allSettled !== 'function') {
  (Promise as any).allSettled = function (iterable: Iterable<any>) {
    const input = Array.from(iterable);
    return Promise.all(
      input.map((p) =>
        Promise.resolve(p).then(
          (value) => ({ status: 'fulfilled', value }),
          (reason) => ({ status: 'rejected', reason })
        )
      )
    );
  };
}

export {};
